import { render } from "./InternationalAdmin.vue?vue&type=template&id=5e630020"
import script from "./InternationalAdmin.vue?vue&type=script&lang=js"
export * from "./InternationalAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__